var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneNumberIcon = function SvgPhoneNumberIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    fillRule: "evenodd",
    d: "M9.248 2.5h5.5c2.261 0 4.1 1.839 4.1 4.099V17.4c0 2.261-1.839 4.1-4.1 4.1h-5.5a4.104 4.104 0 0 1-4.1-4.1V6.599a4.104 4.104 0 0 1 4.1-4.099m1.35 4.95h2.8a.75.75 0 0 0 0-1.5h-2.8a.75.75 0 0 0 0 1.5m.45 9.75c0 .533.417.95.95.95.45 0 .95-.406.95-.95s-.5-.95-.95-.95c-.448 0-.95.406-.95.95",
    clipRule: "evenodd"
  })));
};
export default SvgPhoneNumberIcon;